import CityPagePersianas from "../components/CityPagePersianas";

export default function PersianasFuengirola() {
  return (
    <CityPagePersianas
      name="Fuengirola"
      slug="fuengirola"
      cp="29640"
      poblacion={87007}
      zonaGeo="Costa del Sol Occidental"
      lat={36.5409}
      lng={-4.6261}
      zonas={[
        "Los Boliches",
        "Centro",
        "Torreblanca del Sol",
        "Carvajal",
        "Las Lagunas",
        "El Higuerón",
        "Castillo Sohail",
      ]}
      landmarks={[
        "Castillo Sohail",
        "Paseo Marítimo",
        "Plaza de la Constitución",
        "Puerto Deportivo",
        "Bioparc Fuengirola",
      ]}
      municipiosLimitrofes={[
        "Mijas",
        "Benalmádena",
      ]}
      festivalLocal="Feria del Rosario, primera semana de octubre"
      contextoTipologico="Alta densidad de apartamentos y áticos con terrazas (ideal toldos), edificios años 70-90 con persianas obsoletas, importante comunidad expat europea."
      isCoreZone={true}
    />
  );
}